export const contentTableConfig = {
  title: '家长列表',
  propList: [
    { prop: 'nickName', label: '姓名' },
    { prop: 'phonenumber', label: '电话', minWidth: '100' },
    { prop: 'locationProvince', label: '省份', minWidth: '100' },
    { prop: 'locationCity', label: '城市', minWidth: '100' },
    { prop: 'locationCounty', label: '区/县', minWidth: '100' },
    { prop: 'operableNumber', label: '总课时', minWidth: '100' },
    { prop: 'surplusNumber', label: '剩余课时', minWidth: '100' },
    { prop: 'pay', label: '总共付费(元)', minWidth: '120',slotName:'pay' },
    { prop: 'isPay', label: '状态', minWidth: '100',slotName:'isPay' },
    {
      label: '预约信息',
      minWidth: '140',
      slotName: 'reservation'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false,
  showFooter: true
} 
  